var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total > 0)?_c('div',{staticClass:"pagination-container"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.page,"page-size":_vm.limit,"page-sizes":_vm.pageSizes,"layout":_vm.layout,"total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }